import { render, staticRenderFns } from "./clientOrderQuantity.vue?vue&type=template&id=84af80d2&scoped=true&"
import script from "./clientOrderQuantity.vue?vue&type=script&lang=js&"
export * from "./clientOrderQuantity.vue?vue&type=script&lang=js&"
import style0 from "./clientOrderQuantity.vue?vue&type=style&index=0&id=84af80d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84af80d2",
  null
  
)

export default component.exports